import { tns } from '../../tiny-slider/src/tiny-slider';

class FeaturedPostsSlider {
  constructor() {
    this.FeaturedPostsSlider = null;
    this.init();
  }

  init() {
    document.querySelectorAll('.js-featured-posts-slider').forEach(slider => {
      this.FeaturedPostsSlider = tns({
        container: slider.querySelector('.js-featured-posts-slider-container'),
        navContainer: slider.querySelector('.js-featured-posts-slider-nav'),
        nextButton: slider.querySelector('.js-featured-posts-slider-next'),
        prevButton: slider.querySelector('.js-featured-posts-slider-prev'),
        items: 1,

        onInit: function() {
          // Make keyboard tab-focusable previous and next arrows.
          slider.querySelector('.js-featured-posts-slider-next').setAttribute('tabindex', 0);
        },
      });
    });
  }
}

export default FeaturedPostsSlider;
